import styled from 'styled-components';
import { Input } from '@material-ui/core';

export const LongInput = styled(Input)`
  width: 150%;
  display: flex;
`;
